import PropTypes from 'prop-types';
import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { slugify } from '../../utilities/slugify.js';
import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleSecondaryFeatureBlock = ({
    bodyRichText = null,
    heading = null,
    image = null,
    link = null,
    linkLabel = null,
    smallHeading = null
}) => {
    // misc
    const href = formatLinkBlockToUrl(link);
    const target = isLocalURL(href) ? '_self' : '_blank';
    const rel = isLocalURL(href) ? null : 'noreferrer noopener';

    // render
    return (
        <section className='relative'>
            <div className='layout-container'>
                <div className='layout-grid-negative-gutter flex flex-wrap'>
                    <div className='hidden md:block md:w-1/12 layout-grid-col-padding' />

                    <div className='w-12/12 md:w-5/12 layout-grid-col-padding order-2 md:order-none pb-60 pt-40 md:py-100'>
                        {smallHeading && (
                            <p className='type-style-4'>{smallHeading}</p>
                        )}

                        {heading && (
                            <h2 className='type-style-1 my-20'>{heading}</h2>
                        )}

                        {bodyRichText && (
                            <RichTextWithGlossary
                                className='type-style-4 mb-30 rich-text'
                                html={bodyRichText} />
                        )}

                        {linkLabel && (
                            <a
                                className={`pill-button type-style-4 mt-30 gtm-${slugify(linkLabel)}`}
                                href={href}
                                rel={rel}
                                target={target}>
                                {linkLabel}
                            </a>
                        )}
                    </div>

                    <div className='hidden md:block md:w-1/12 layout-grid-col-padding' />

                    <div className='w-12/12 md:w-5/12 layout-grid-col-padding order-1 md:order-none md:aspect-square'>
                        {image && (
                            <figure className='full-width md:full-width-reset h-full'>
                                <div className='h-full md:-mr-60'>
                                    <img
                                        alt={image.alt}
                                        className='h-full w-full object-center object-cover pointer-events-none'
                                        height={image.height}
                                        loading='lazy'
                                        src={image.px2}
                                        width={image.width} />
                                </div>
                            </figure>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    bodyRichText: PropTypes.string,
    heading: PropTypes.string,
    image: PropTypes.object,
    link: PropTypes.object,
    linkLabel: PropTypes.string,
    smallHeading: PropTypes.string
};


ModuleSecondaryFeatureBlock.propTypes = propTypes;

export default ModuleSecondaryFeatureBlock;
